<template>
  <div class="flex flex-wrap gap-6">
    <div
      v-for="entry in chartDataByCurrency"
      :key="entry.currency"
      class="flex flex-col items-center"
    >
      <div class="text-neutral-500 text-xs uppercase mb-1">
        {{ entry.currency }}
      </div>
      <div :ref="wrapperRef(entry.currency)" />
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'
import { postingsForAccount, sumPostingsForCurrency } from '@/parse-and-play/utils.js'

export default {
  props: ['sheet', 'transactions'],
  computed: {
    // One chart's worth of data per currency present -- mixing currencies
    // into a single ring would size slices by unrelated units.
    chartDataByCurrency () {
      const postings = this.transactions.reduce((acc, t) => acc.concat(t.postings), [])
      const path = this.path ? new RegExp(`^${this.path}:`) : /^/
      const currencies = [...new Set(postings.map((p) => p.currency).filter(Boolean))]

      return currencies.map((currency) => {
        const currencyPostings = postings.filter((p) => p.currency === currency)
        const accounts = currencyPostings
          .filter((posting) => path.exec(posting.account))
          .map((posting) => this.path ? [this.path, posting.account.replace(path, '').split(':')[0]].join(':') : posting.account.replace(path, '').split(':')[0])
        const uniqueAccounts = [...new Set(accounts)]
        const labels = uniqueAccounts
        const data = uniqueAccounts.map((account) => {
          return Math.abs(sumPostingsForCurrency(postingsForAccount(currencyPostings, account), currency))
        })

        return {
          currency,
          labels,
          datasets: [{
            label: currency,
            data
          }]
        }
      })
    }
  },
  watch: {
    chartDataByCurrency () {
      this.$nextTick(() => this.makeCharts())
    }
  },
  mounted () {
    this.makeCharts()
  },
  methods: {
    wrapperRef (currency) {
      return `chartWrapper-${currency}`
    },

    makeCharts () {
      for (const entry of this.chartDataByCurrency) {
        this.makeChart(entry)
      }
    },

    makeChart (entry) {
      const wrapper = this.$refs[this.wrapperRef(entry.currency)]
      if (!wrapper) return

      const canvas = document.createElement('canvas')

      canvas.className = 'block mx-auto mt-8 mb-5'

      wrapper.innerHTML = ''
      wrapper.appendChild(canvas)

      const chart = new Chart(canvas, {
        type: 'polarArea',
        data: { labels: entry.labels, datasets: entry.datasets },
        options: {
          responsive: true,
          animation: {
            duration: 0
          },
          onClick: (evt) => {
            const elements = chart.getElementsAtEventForMode(evt, 'index', { intersect: true }, false)
            const index = elements[0].index
            const label = chart.data.labels[index]

            this.prefix = label
          }
        }
      })
    }
  }
}
</script>
